exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orders_actionButtonGroup{flex-direction:row}.orders_actionButtonGroup,.orders_button_link{display:flex;justify-content:center;align-items:center}.orders_button_link{margin:5px;text-decoration:none}", ""]);

// exports
